import { render, staticRenderFns } from "./QuanLyMerchantForm.vue?vue&type=template&id=2f4be5ea&scoped=true&"
import script from "./QuanLyMerchantForm.vue?vue&type=script&lang=js&"
export * from "./QuanLyMerchantForm.vue?vue&type=script&lang=js&"
import style0 from "./QuanLyMerchantForm.vue?vue&type=style&index=0&id=2f4be5ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4be5ea",
  null
  
)

export default component.exports